import { shallowEqual } from '@affine/core/components/page-list';
import { listPropsAtom } from '@affine/core/components/page-list/scoped-atoms';
import type { GetWikiDocByWorkspaceResponseOutputData } from '@docnboard/rest';
import { selectAtom } from 'jotai/utils';

import type { RequiredProps } from './types';

export const requiredPropNames = [
  'docCollection',
  'rowAsLink',
  'selectedIds',
  'onSelectedIdsChange',
] as const;

export const listsPropsAtom = selectAtom(
  listPropsAtom,
  props => {
    return Object.fromEntries(
      requiredPropNames.map(name => [name, props?.[name]])
    ) as RequiredProps<GetWikiDocByWorkspaceResponseOutputData>;
  },
  shallowEqual
);
